// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kKOs","select":"styles_select__2EMrC"};